<ion-app>
  <!-- Session banners: a strip pinned to the top of the shell; the routed page is pushed down by its height. -->
  <app-shell-top-banners>
    <app-impersonation-banner></app-impersonation-banner>
    <app-support-member-banner></app-support-member-banner>
  </app-shell-top-banners>
  <!-- Fullscreen Mode Header -->
  @if (presentationState.mode === 'fullscreen' && presentationState.options?.showCloseButton) {
    <ion-header class="fullscreen-header">
      <ion-toolbar>
        <ion-title>
          {{ presentationState.options?.headerTitle || '' }}
          @if (presentationState.options?.headerSubtitle) {
            <span class="header-subtitle">
              {{ presentationState.options?.headerSubtitle }}
            </span>
          }
        </ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="closeFullscreen()">
            <ion-icon name="close" slot="icon-only"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
  }

  <!-- #06 app-shell payment enforcement banner. Self-suppresses on /billing,
  /signup, /login, /auth (those routes own their own messaging). -->
  <app-billing-enforcement-banner></app-billing-enforcement-banner>

  @if (showFirstRunThemePrompt) {
    <app-first-run-theme-prompt
      (decided)="onFirstRunThemeDecided()"
    ></app-first-run-theme-prompt>
  }

  <ion-router-outlet [class.fullscreen-mode]="presentationState.mode === 'fullscreen'"></ion-router-outlet>

  @if (isDiagnosticCaptureEnabled && isDiagnosticBannerVisible) {
    <div
      class="diagnostic-capture-banner"
      [class.active]="isDiagnosticCaptureActive"
      [class.fade-out]="isDiagnosticBannerFadingOut"
      >
      @if (!diagnosticCopiedConfirmation) {
        <span class="diagnostic-capture-label">
          Diagnostic Capture:
          <strong>{{ isDiagnosticCaptureActive ? 'ON' : 'OFF' }}</strong>
        </span>
      }
      @if (diagnosticCopiedConfirmation) {
        <span class="diagnostic-capture-copied">
          Session ID copied!
        </span>
      }
      @if (isDiagnosticCaptureBusy) {
        <span class="diagnostic-capture-busy">Updating...</span>
      }
      @if (diagnosticSessionError && !diagnosticCopiedConfirmation) {
        <span class="diagnostic-capture-error">
          {{ diagnosticSessionError }}
        </span>
      }
      @if (diagnosticSessionId) {
        <span class="diagnostic-capture-session">
          {{ diagnosticSessionId }}
        </span>
      }
      @if (!diagnosticCopiedConfirmation) {
        <button
          type="button"
          class="diagnostic-capture-toggle"
          [disabled]="isDiagnosticCaptureBusy"
          (click)="toggleDiagnosticCapture()"
          >
          {{ isDiagnosticCaptureBusy ? 'Updating...' : (isDiagnosticCaptureActive ? 'Stop' : 'Start') }} Capture
        </button>
      }
    </div>
  }

  <!-- Chat Toggle Button (Floating Action Button) -->
  @if (showChatToggle) {
    <app-chat-toggle></app-chat-toggle>
  }

  <!-- Unified chat overlay: desktop sidebar/expanded, mobile fullscreen; the Solo panel or the ChatKit panel by surface -->
  @if (showChatPanel && chatOverlayMode === 'expanded') {
    <div
      class="chat-overlay-backdrop"
      (click)="closeChatOverlay()"
      aria-hidden="true"
    ></div>
  }
  @if (showChatPanel) {
    <div
      class="chat-overlay-host"
      [class.panel]="chatOverlayMode === 'panel'"
      [class.expanded]="chatOverlayMode === 'expanded'"
      [class.full]="chatOverlayMode === 'full'"
      >
      <!-- Channels C0b: the surface (GET /api/agents/chat/surface, read once per sign-in) picks the panel. -->
      @if (chatSurface === 'agents') {
        <app-solo-chat-overlay></app-solo-chat-overlay>
      } @else if (chatSurface === 'chatkit') {
        <app-chat-overlay></app-chat-overlay>
      } @else {
        <div class="chat-overlay-pending" role="status" aria-busy="true"><ion-spinner name="crescent"></ion-spinner></div>
      }
    </div>
  }

  <!-- #08: AI credits gauge in the app shell. Hides on /billing/* and auth
  routes; collapses to lock icon under restricted enforcement. -->
  <app-billing-sidebar-credits-gauge></app-billing-sidebar-credits-gauge>

  <app-build-stamp></app-build-stamp>

  <app-passkey-prompt></app-passkey-prompt>

</ion-app>
